import React, { createContext, useState, useContext, useEffect } from 'react';
import { Helpers } from '../../utilities/helpers'

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {

    function getThemePreference() {
        //check for previous selected site theme
        const preferredTheme = localStorage.getItem('theme');

        if (preferredTheme) {
            return preferredTheme
        }
        //check for system theme
        const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

        return systemTheme
    }

    async function getAgent() {
        const agent = await Helpers.getInStorage('sales_agent', true)
        return !!agent
    }

    const [theme, setTheme] = useState(() => getThemePreference());

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme])

    useEffect(() => {
        const initialTheme = getAgent() ? 'light' : theme
        setTheme(initialTheme);
    }, [])

    const toggleTheme = () => {
        const newTheme = (theme === 'light' ? 'dark' : 'light');
        setTheme(newTheme);
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);

//if (&& window.matchMedia('(prefers-color-scheme: dark)').matches)
